/*! @azure/msal-common v16.11.1 2026-07-07 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.11.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
